// extracted by mini-css-extract-plugin
module.exports = {"Container":"BottomBar_Container__l3QxY","NextButton":"BottomBar_NextButton__3hdra"};